module.exports = __webpack_public_path__ + "media/images/icons/filled/alipay-square-f8b8bf3475ba47a10943da4f68ce3613.svg";